/**
 * Small upward-pointing chevron used as a sort-direction indicator in table
 * headers. Rotate 180° via CSS to indicate descending order.
 */
export function SortChevronIcon() {
  return (
    <svg width="9" height="5" viewBox="0 0 8.167 4.667" fill="none">
      <path
        d="M7.583 4.083L4.083 0.583L0.583 4.083"
        stroke="currentColor"
        strokeWidth="1.167"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
